import { useTranslation } from 'react-i18next';

import { ChartKeySwatch, type ChartKeySwatchProps } from '@/components/charts/legend';

import { BADGE_KIND_ORDER } from '../../helpers/groupTrack';
import { EventIcon } from '../EventBadge/EventBadge';

import styles from './BoardLegend.module.scss';

type SwatchKind = 'active' | 'planned' | 'completed' | 'partialHarvest' | 'noBioscope';

/** Each mark drawn like the bar or tick it explains, in the legend's order. */
const SWATCHES: { kind: SwatchKind; swatch: ChartKeySwatchProps }[] = [
    {
        kind: 'active',
        swatch: {
            shape: 'square',
            color: 'var(--color-success-border)',
            outline: 'var(--color-success-fill)',
        },
    },
    {
        kind: 'planned',
        swatch: {
            shape: 'square',
            color: 'var(--color-success-bg)',
            outline: 'var(--color-success-fill)',
            className: styles.dashed,
        },
    },
    {
        kind: 'completed',
        swatch: {
            shape: 'square',
            color: 'color-mix(in srgb, var(--color-border-accent) 18%, var(--color-bg-surface))',
            outline: 'var(--color-border-accent)',
        },
    },
    { kind: 'partialHarvest', swatch: { shape: 'line', color: 'var(--tint-red-fg)' } },
    {
        kind: 'noBioscope',
        swatch: {
            shape: 'square',
            color: 'var(--color-bg-surface)',
            outline: 'var(--color-border-input)',
            className: styles.hatched,
        },
    },
];
export default function BoardLegend() {
    const { t } = useTranslation('fishGroups');

    return (
        <ul className={styles.legend} aria-label={t('board.legend.title')}>
            {SWATCHES.map(({ kind, swatch }) => (
                <li key={kind} className={styles.item}>
                    <ChartKeySwatch {...swatch} />
                    {t(`board.legend.${kind}`)}
                </li>
            ))}
            {BADGE_KIND_ORDER.map((kind) => (
                <li key={kind} className={styles.item}>
                    <EventIcon kind={kind} compact />
                    {t(`board.events.${kind}`)}
                </li>
            ))}
        </ul>
    );
}
